import { createSlice } from '@reduxjs/toolkit';
import { getAdmins, getUser, getUserdetails } from '../Localstorage/localstorage';
import moment from 'moment';

const appointmentSlice = createSlice({
  name: 'appointment',
  initialState: {
    appointments: [],
    appointmentsCalendly:[],
    command: '',
    user: getUser(),
    userdetails: getUserdetails(),
    users:[],
    admins: getAdmins(),
    pagination:moment().startOf('month').toISOString()
  },
  reducers: {
    setAppointment: (state, action) => {
      // Appends the new item to the existing mailRooms array
      state.appointments = [...state.appointments, action.payload];
    },
    setAppointmentLoad: (state, action) => {
        state.appointments = action.payload;
    },
    setAppointmentsCalendly: (state, action) => {
      // Appends the new item to the existing mailRooms array
      state.appointmentsCalendly = [...state.appointmentsCalendly, action.payload];
    },
    setAppointmentsCalendlyLoad: (state, action) => {
        state.appointmentsCalendly = action.payload;
    },
    setAppointmentsCalendlyDelete: (state, action) => {
      state.appointmentsCalendly = state.appointmentsCalendly.filter((_, index) => 
        index !== action.payload);
    },
    setAppointmentUpdate: (state, action) => {
      state.appointments = state.appointments.map(appointment => 
        appointment.id === action.payload.id 
            ? { ...appointment, ...action.payload }  // Merge existing appointment with updatedComment
            : appointment // Leave other comments unchanged
    );},
    setAppointmentDelete: (state, action) => {
      state.appointments = state.appointments.filter(appointment => 
        appointment.id != action.payload.id);},
    setCommand: (state, action) => {
      // This one seems to replace command entirely, no change needed here
      state.command = action.payload;
    },
    setUsers: (state, action) => {
      // This one seems to replace user entirely, no change needed here
      state.users = action.payload;
    },
    setPagination:(state, action) => {
        state.pagination = action.payload;
    },
  },
  
});

export const {
  appointments,
  appointmentsCalendly,
  command,
  user,
  userdetails,
  users,
  admins,
  pagination,
  setAppointment,
  setAppointmentLoad,
  setAppointmentInWacht,
  setAppointmentLoadInWacht,
  setAppointmentsCalendly,
  setAppointmentsCalendlyLoad,
  setAppointmentUpdate,
  setAppointmentDelete,
  setAppointmentsCalendlyDelete,
  setCommand,
  setPagination,
  setUsers
} = appointmentSlice.actions;

export default appointmentSlice.reducer;
